import React from "react";

const FONT_LINK =
  "https://fonts.googleapis.com/css2?family=Poppins:wght@800&display=swap";

function useGoogleFont(href) {
  if (typeof document !== "undefined") {
    if (!document.querySelector(`link[href="${href}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
    }
  }
}

export default function PinterestPinTemplate14({
  foodImageUrl1,
  foodImageUrl2,
  title = "Flourless Sweet Potato Ginger Cake",
  focusKeyword,
  domain
}) {
  useGoogleFont(FONT_LINK);

  const displayTitle = focusKeyword || title;
  const bgImage2 = foodImageUrl2 || foodImageUrl1;

  return (
    <div
      id="pinterest-pin-template"
      style={{
        width: 474,
        height: 948,
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1A1412",
        WebkitFontSmoothing: "antialiased"
      }}
    >
      {/* ===== TOP FOOD IMAGE — fills upper half ===== */}
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          width: 474,
          height: 474,
          backgroundImage: foodImageUrl1 ? `url(${foodImageUrl1})` : "none",
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundColor: "#c8a882"
        }}
      />

      {/* ===== BOTTOM FOOD IMAGE — fills lower half ===== */}
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 474,
          width: 474,
          height: 474,
          backgroundImage: bgImage2 ? `url(${bgImage2})` : "none",
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundColor: "#b89060"
        }}
      />

      {/* ===== CENTER OVERLAY — perfectly centered via transform ===== */}
      <div
        style={{
          position: "absolute",
          left: 0,
          top: "50%",
          transform: "translateY(-50%)",
          width: 474,
          zIndex: 10
        }}
      >
        {/* ===== TOP DIVIDER LINE ===== */}
        <div
          style={{
            width: 474,
            height: 4,
            backgroundColor: "#C75B39"
          }}
        />

        {/* ===== TITLE BLOCK ===== */}
        <div
          style={{
            width: 474,
            height: 140,
            backgroundColor: "#1A1412",
            paddingLeft: 30,
            paddingRight: 30,
            boxSizing: "border-box",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden"
          }}
        >
          <div
            style={{
              fontFamily: '"Poppins", "Arial Black", Arial, sans-serif',
              fontSize: 32,
              fontWeight: 800,
              color: "#FFF7F2",
              textAlign: "center",
              lineHeight: 1.28,
              letterSpacing: "-0.2px",
              userSelect: "none",
              width: "100%",
              margin: 0,
              transform: "translateY(-11px)"
            }}
          >
            {displayTitle}
          </div>
        </div>

        {/* ===== BOTTOM DIVIDER LINE ===== */}
        <div
          style={{
            width: 474,
            height: 4,
            backgroundColor: "#C75B39"
          }}
        />
      </div>
    </div>
  );
}
